import script from "./ViewAllTeams.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAllTeams.vue?vue&type=script&setup=true&lang=js"

import "./ViewAllTeams.vue?vue&type=style&index=0&id=40767bbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40767bbb"]])

export default __exports__